(function () {
  "use strict";
  /* The snippet is rendered by both the drawer and the cart page, so this file
     can be executed twice on /cart. Two live instances race sync() and each adds
     the reward line once — one guard, one instance. */
  if (window.__bdKitActive) return;
  window.__bdKitActive = true;
  var cfgEl = document.getElementById("bd-kit-config");
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.tiers || !CFG.tiers.length) return;

  var preview = false;
  try {
    var qs = location.search || "";
    if (qs.indexOf("bdkit=1") >= 0) sessionStorage.setItem("bdkit_preview", "1");
    if (qs.indexOf("bdkit=0") >= 0) sessionStorage.removeItem("bdkit_preview");
    preview = sessionStorage.getItem("bdkit_preview") === "1";
  } catch (e) {}
  if (!CFG.live && !preview) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/",
    OPTOUT = "bdkit_declined",
    busy = false,
    busyAt = 0,
    failCount = 0,
    addCount = 0,
    lastSig = "";

  function getCart() {
    return fetch(root + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function addLine(id, props) {
    return fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: props || {} }] })
    }).then(function (r) { return r.json().catch(function () { return null; }); });
  }

  function removeLine(key) { return changeQty(key, 0); }

  function changeQty(key, qty) {
    return fetch(root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json().catch(function () { return null; }); });
  }

  function declined() {
    try { return (sessionStorage.getItem(OPTOUT) || "").split(",").filter(Boolean); }
    catch (e) { return []; }
  }
  function setDeclined(list) {
    try { sessionStorage.setItem(OPTOUT, list.filter(Boolean).join(",")); } catch (e) {}
  }
  function isDeclined(key) { return declined().indexOf(key) >= 0; }
  function decline(key) {
    var d = declined();
    if (d.indexOf(key) < 0) d.push(key);
    setDeclined(d);
  }
  function undecline() { setDeclined([]); }

  var REWARDS = {}, VARIANT_TO_KEY = {};
  CFG.tiers.forEach(function (t) {
    t.rewards.forEach(function (r) {
      REWARDS[r.key] = r;
      r.variants.forEach(function (v) { VARIANT_TO_KEY[v.id] = r.key; });
    });
  });

  function isReward(item) {
    return !!VARIANT_TO_KEY[item.variant_id] && !!(item.properties && item.properties._bd_kit);
  }

  /* --- sold-out kill switch (Nathan, 14 Aug 2026) ---------------------------
     If ANY reward variant is sold out — any size, any tier — the whole ladder
     stands down and the theme's native free-shipping bar takes over (removing
     bd-kit-on un-hides it; see bd-kit.css). A half-available ladder is worse
     than none: a sold-out sized reward would gate checkout on a size that
     can't be picked. The snippet bakes "merchOk" from live availability on
     every render; a mid-session sellout is caught by absorbQual re-reading
     each re-rendered config, and by any reward add coming back as an error.
     Reward lines already in the cart are removed so nothing sits there to be
     charged full price if the free-gift discount stops matching. */
  var KILL = "bdkit_kill", killed = false;
  function merchDead(cfg) { return !!cfg && cfg.merchOk === false; }
  function addFailed(res) {
    /* /cart/add.js error shape is {status:422,...}; success is {items:[...]}.
       A null res (challenge page, network blip) is NOT treated as sold out. */
    return !!(res && res.status && !res.items);
  }
  function die() {
    if (killed) return;
    killed = true;
    busy = false;
    try { sessionStorage.setItem(KILL, "1"); } catch (e) {}
    try { mo.disconnect(); } catch (e) {}
    try { if (t) { clearTimeout(t); t = null; } } catch (e) {}
    document.querySelectorAll(".bd-kit").forEach(function (n) { n.remove(); });
    document.documentElement.classList.remove("bd-kit-on");
    document.documentElement.classList.remove("bd-kit-gate");
    cleanupRewards(0, false);
  }
  function cleanupRewards(depth, removedAny) {
    getCart().then(function (cart) {
      var line = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (isReward(cart.items[i])) { line = cart.items[i]; break; }
      }
      if (!line) {
        if (removedAny) { applyCartClasses(cart); refreshCartUI(); }
        return;
      }
      if (depth >= 5) return;
      removeLine(line.key).then(function () { cleanupRewards(depth + 1, true); }, function () {});
    }).catch(function () {});
  }
  /* Fresh Liquid is authoritative: a restock clears a kill left in the session
     by a failed add, so recovery needs no customer action beyond a page load. */
  try { if (!merchDead(CFG)) sessionStorage.removeItem(KILL); } catch (e) {}
  function isProtection(item) {
    return CFG.protectionHandle && item.handle === CFG.protectionHandle;
  }

  /* The drawer and the cart page each render their own #bd-kit-config with a
     "qualifying" {variant_id: bool} map (the unpublished qualifying collection is
     invisible to Liquid, so the snippet replicates its tag rule). Merge every map
     we can see; an unknown variant counts as NOT qualifying — under-counting is
     the safe direction. */
  var QUAL = {};
  /* The map also persists per-tab: a bfcache-restored page carries a config from
     before the cart changed, and an under-counted total here makes reconcile
     rip out a reward the customer legitimately earned. */
  try {
    (sessionStorage.getItem("bdkit_qual") || "").split(",").filter(Boolean).forEach(function (k) { QUAL[k] = true; });
  } catch (e) {}
  function absorbQual() {
    var deadCfg = false;
    document.querySelectorAll("#bd-kit-config").forEach(function (el) {
      try {
        var c = JSON.parse(el.textContent);
        if (merchDead(c)) deadCfg = true;
        var q = c.qualifying;
        if (q) Object.keys(q).forEach(function (k) { if (q[k]) QUAL[k] = true; });
      } catch (e) {}
    });
    try { sessionStorage.setItem("bdkit_qual", Object.keys(QUAL).join(",")); } catch (e) {}
    /* The drawer re-renders its config on every cart mutation, so a mid-session
       sellout shows up here within one sync. */
    if (deadCfg) die();
  }
  absorbQual();
  if (merchDead(CFG)) die();
  if (killed) return;

  function isQualifying(item) { return QUAL[item.variant_id] === true; }

  function qualifyingTotal(cart) {
    return cart.items.reduce(function (n, i) {
      return isReward(i) || isProtection(i) || !isQualifying(i) ? n : n + i.final_line_price;
    }, 0);
  }
  function shippingTotal(cart) {
    return cart.items.reduce(function (n, i) {
      return isReward(i) || isProtection(i) ? n : n + i.final_line_price;
    }, 0);
  }

  function rewardLine(cart, key) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isReward(it) && VARIANT_TO_KEY[it.variant_id] === key) return it;
    }
    return null;
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return "$" + v.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function stops() {
    var out = [];
    if (CFG.shipping && CFG.shipping.threshold > 0) {
      out.push({ kind: "ship", threshold: CFG.shipping.threshold, label: CFG.shipping.label || "Free shipping", rewards: [] });
    }
    CFG.tiers.forEach(function (t) {
      var label = t.rewards.map(function (r) { return r.short || r.title; }).join(" + ");
      out.push({ kind: "tier", threshold: t.threshold, label: label, rewards: t.rewards });
    });
    return out.sort(function (a, b) { return a.threshold - b.threshold; });
  }

  function evaluate(cart) {
    var qual = qualifyingTotal(cart),
      ship = shippingTotal(cart),
      all = stops();
    all.forEach(function (s) {
      s.total = s.kind === "ship" ? ship : qual;
      s.on = s.total >= s.threshold;
    });
    var next = null;
    all.forEach(function (s) { if (!s.on && !next) next = s; });
    var earned = [];
    CFG.tiers.forEach(function (t) {
      if (qual >= t.threshold) t.rewards.forEach(function (r) { earned.push(r); });
    });
    var pct = 100;
    for (var i = 0; i < all.length; i++) {
      if (!all[i].on) {
        var floor = i === 0 ? 0 : all[i - 1].threshold,
          span = all[i].threshold - floor,
          within = span > 0 ? (all[i].total - floor) / span : 0;
        pct = ((i + Math.max(0, Math.min(1, within))) / all.length) * 100;
        break;
      }
    }
    return { total: qual, ship: ship, stops: all, next: next, earned: earned, pct: pct };
  }

  function reconcile(cart, state) {
    var earnedKeys = state.earned.map(function (r) { return r.key; });
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isReward(it)) {
        var key = VARIANT_TO_KEY[it.variant_id];
        if (earnedKeys.indexOf(key) < 0) { busy = true; busyAt = Date.now(); removeLine(it.key).then(after, after); return true; }
        if (it.quantity > 1) { busy = true; busyAt = Date.now(); changeQty(it.key, 1).then(after, after); return true; }
      }
    }
    if (addCount < 6) {
      for (var j = 0; j < state.earned.length; j++) {
        var r = state.earned[j];
        if (!r.sized && !isDeclined(r.key) && !rewardLine(cart, r.key)) {
          var v = r.variants.filter(function (x) { return x.available; })[0];
          if (v) {
            busy = true;
            busyAt = Date.now();
            addCount++;
            addLine(v.id, { _bd_kit: r.key }).then(function (res) {
              /* Config said available but Shopify refused the add — someone
                 bought the last one this second. Stand the ladder down. */
              if (addFailed(res)) { die(); return; }
              after();
            }, after);
            return true;
          }
        }
      }
    }
    return false;
  }

  /* After a cart mutation: sync straight away so the bar/reward reflects the new
     cart within one fetch, and kick the theme's own re-render in parallel. The
     MutationObserver re-mounts us when that re-render lands, so nothing here
     needs to wait on it — the old serial wait was most of Nick's "5 seconds". */
  function after() {
    busy = false;
    /* A mutation that settled after the kill (in-flight race) may have landed a
       reward line — sweep again instead of resuming the loop. */
    if (killed) { cleanupRewards(0, false); return; }
    var refreshed = refreshCartUI();
    sync();
    refreshed.then(schedule);
  }

  function build(cart, state) {
    var wrap = document.createElement("div");
    wrap.className = "bd-kit";
    if (CFG.accent) wrap.style.setProperty("--bd-accent", CFG.accent);
    var all = state.stops, pct = state.pct, msg;
    if (state.next) {
      var away = state.next.threshold - state.next.total;
      if (state.next.kind === "ship") {
        msg = "<b>" + money(away) + "</b> from free shipping";
      } else {
        var names = state.next.rewards.map(function (r) { return r.title; }).join(" + ");
        msg = "<b>" + money(away) + "</b> from free " + names;
      }
    } else {
      msg = "Free shipping and every reward unlocked.";
    }
    var pips = "", marks = "";
    all.forEach(function (st, i) {
      var on = st.on,
        left = ((i + 1) / all.length) * 100,
        last = i === all.length - 1;
      pips += '<span class="bd-kit__pip' + (on ? " is-on" : "") + '" style="left:' + left + '%"></span>';
      marks += '<span class="bd-kit__mark' + (on ? " is-on" : "") + (last ? " is-last" : "") + '" style="left:' + left + '%"><span class="bd-kit__amt">' + money(st.threshold) + '</span><span class="bd-kit__what">' + st.label + "</span></span>";
    });
    var rows = "";
    state.earned.forEach(function (r) {
      var line = rewardLine(cart, r.key);
      if (!(line && !changing[r.key]) && !isDeclined(r.key)) {
        var img = r.image ? '<img class="bd-kit__thumb" src="' + r.image + '" alt="" loading="lazy">' : '<span class="bd-kit__thumb"></span>';
        rows += '<div class="bd-kit__reward' + (line ? " is-changing" : "") + '" data-key="' + r.key + '">' + img + '<div><div class="bd-kit__rname">' + r.title + '</div><div class="bd-kit__rsub">' + (line ? "Pick a different size" : '<span class="bd-kit__ok">Unlocked</span> &mdash; pick your size<span class="bd-kit__req">*</span>') + '</div></div><div class="bd-kit__free">Free</div>' + sizeRow(r, line ? line.variant_id : null) + "</div>";
      }
    });
    var anyDeclined = state.earned.some(function (r) { return isDeclined(r.key); }),
      restore = anyDeclined ? '<button type="button" class="bd-kit__restore" data-act="restore">Changed your mind? Claim your free gear</button>' : "";
    wrap.innerHTML = '<div class="bd-kit__head"><div class="bd-kit__title">Bushdoof Rewards</div><div class="bd-kit__sub">' + msg + '</div></div><div class="bd-kit__rail"><span class="bd-kit__fill" style="width:' + pct + '%"></span>' + pips + '<span class="bd-kit__cap" style="left:clamp(9px,' + pct + '%,calc(100% - 9px))"></span></div><div class="bd-kit__marks">' + marks + "</div>" + (rows ? '<div class="bd-kit__rewards">' + rows + "</div>" : "") + restore;
    wrap.addEventListener("click", function (ev) {
      var btn = ev.target.closest("button");
      if (!btn || busy) return;
      var act = btn.getAttribute("data-act");
      if (act === "restore") { undecline(); sync(); return; }
      var key = btn.getAttribute("data-key");
      if (!key) return;
      if (act === "cancel") { changing[key] = false; sync(); return; }
      if (act === "decline") {
        decline(key);
        var ln = rewardLine(lastCart, key);
        if (ln) { busy = true; wrap.classList.add("is-busy"); removeLine(ln.key).then(after); }
        else sync();
        return;
      }
      if (act === "pick") {
        var vid = Number(btn.getAttribute("data-variant")),
          current = rewardLine(lastCart, key);
        changing[key] = false;
        if (current && current.variant_id === vid) { sync(); return; }
        busy = true;
        wrap.classList.add("is-busy");
        var p = current ? removeLine(current.key) : Promise.resolve();
        p.then(function () { return addLine(vid, { _bd_kit: key }); }).then(function (res) {
          if (addFailed(res)) { die(); return; }
          after();
        });
      }
    });
    return wrap;
  }

  function sizeRow(r, pickedId) {
    var chips = r.variants.map(function (v) {
        var cls = "bd-kit__size" + (pickedId && v.id === pickedId ? " is-picked" : "");
        return '<button type="button" class="' + cls + '" data-act="pick" data-key="' + r.key + '" data-variant="' + v.id + '"' + (v.available ? "" : " disabled") + ">" + v.title + "</button>";
      }).join(""),
      outs = pickedId
        ? '<span class="bd-kit__outs"><button type="button" class="bd-kit__decline" data-act="cancel" data-key="' + r.key + '">Cancel</button><button type="button" class="bd-kit__decline" data-act="decline" data-key="' + r.key + '">Remove</button></span>'
        : '<span class="bd-kit__outs"><button type="button" class="bd-kit__decline" data-act="decline" data-key="' + r.key + '">No thanks</button></span>';
    return '<div class="bd-kit__sizes">' + chips + outs + "</div>";
  }

  function mount(cart, state) {
    document.querySelectorAll(".bd-kit").forEach(function (n) { n.remove(); });
    if (!cart.items.filter(function (i) { return !isReward(i) && !isProtection(i); }).length) {
      document.documentElement.classList.remove("bd-kit-on");
      document.documentElement.classList.remove("bd-kit-gate");
      return;
    }
    var hosts = [];
    document.querySelectorAll(".drawer__shipping-bar").forEach(function (b) {
      if (b.parentElement) hosts.push({ host: b.parentElement, before: b.nextSibling });
    });
    if (!hosts.length) {
      document.querySelectorAll('[name="checkout"]').forEach(function (b) {
        if (b.parentElement) hosts.push({ host: b.parentElement, before: b.parentElement.firstChild });
      });
    }
    document.documentElement.classList.add("bd-kit-on");
    hosts.forEach(function (h) {
      try {
        var node = build(cart, state);
        if (h.before && h.before.parentNode === h.host) h.host.insertBefore(node, h.before);
        else h.host.appendChild(node);
      } catch (e) { console.warn("bd-kit mount", e); }
    });
    updateGate();
  }

  /* --- checkout gate: an unlocked sized reward must be picked or declined ---- */
  /* Sized rewards can't be auto-added (we don't know the size), so an unlocked
     one just sits in the bar waiting. Until every one is resolved — size picked
     or "No thanks" — View cart / Checkout are intercepted and a red line points
     at the row. Express wallet buttons render inside iframes where a click can't
     be intercepted, so those are disabled by CSS via the bd-kit-gate class. */
  function pendingRewards() {
    if (killed || !lastCart || !lastState) return [];
    return lastState.earned.filter(function (r) {
      return r.sized && !isDeclined(r.key) && !rewardLine(lastCart, r.key);
    });
  }

  function updateGate() {
    document.documentElement.classList.toggle("bd-kit-gate", pendingRewards().length > 0);
  }

  function showGateError() {
    var pend = pendingRewards().map(function (r) { return r.key; });
    document.querySelectorAll(".bd-kit__reward").forEach(function (row) {
      if (pend.indexOf(row.getAttribute("data-key")) < 0) return;
      row.classList.add("is-required");
      if (!row.querySelector(".bd-kit__err")) {
        var e = document.createElement("div");
        e.className = "bd-kit__err";
        e.textContent = "Pick a size for your free reward, or tap ‘No thanks’.";
        row.appendChild(e);
      }
    });
    var first = document.querySelector(".bd-kit__reward.is-required");
    if (first && first.scrollIntoView) first.scrollIntoView({ block: "nearest", behavior: "smooth" });
  }

  document.addEventListener("click", function (ev) {
    if (!pendingRewards().length) return;
    var go = ev.target.closest && ev.target.closest('[name="checkout"], .cart__checkout-button, .coverr__go, .cart__ctas a[href*="/cart"]');
    if (!go) return;
    ev.preventDefault();
    ev.stopPropagation();
    showGateError();
  }, true);

  document.addEventListener("submit", function (ev) {
    if (!pendingRewards().length) return;
    var f = ev.target;
    if (f && /\/cart/.test(f.getAttribute("action") || "")) {
      ev.preventDefault();
      ev.stopPropagation();
      showGateError();
    }
  }, true);

  /* Rows are found by the line-item KEY stamped on the remove button (stable no
     matter how lines shift), falling back to the positional row id only when the
     theme markup predates the data-key attribute. */
  function rowFor(item, idx) {
    try {
      var btn = document.querySelector('cart-remove-button[data-key="' + item.key + '"]');
      if (btn) {
        var row = btn.closest("tr, .cart-item");
        if (row) return row;
      }
    } catch (e) {}
    return document.getElementById("CartDrawer-Item-" + (idx + 1)) || document.getElementById("CartItem-" + (idx + 1));
  }

  function decorate(cart) {
    cart.items.forEach(function (item, idx) {
      if (!isReward(item)) return;
      var row = rowFor(item, idx);
      if (!row || row.querySelector(".bd-kit-line-badge")) return;
      var key = VARIANT_TO_KEY[item.variant_id],
        r = REWARDS[key],
        name = row.querySelector(".cart-item__name");
      if (name) {
        var b = document.createElement("span");
        b.className = "bd-kit-line-badge";
        b.textContent = "Free reward";
        name.parentNode.insertBefore(b, name.nextSibling);
        if (r && r.sized && r.variants.length > 1) {
          var c = document.createElement("button");
          c.type = "button";
          c.className = "bd-kit-line-change";
          c.setAttribute("data-bd-change", key);
          c.textContent = "Change size";
          name.parentNode.insertBefore(c, b.nextSibling);
        }
      }
      var q = row.querySelector(".quantity, quantity-input");
      if (q) q.style.display = "none";
    });
  }

  var changing = {};
  document.addEventListener("click", function (ev) {
    var btn = ev.target.closest && ev.target.closest("[data-bd-change]");
    if (!btn) return;
    ev.preventDefault();
    if (busy || killed) return;
    changing[btn.getAttribute("data-bd-change")] = true;
    sync();
    setTimeout(function () {
      var panel = document.querySelector(".bd-kit__reward.is-changing");
      if (panel && panel.scrollIntoView) panel.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }, 350);
  });

  function refreshCartUI() {
    var done = function () { return new Promise(function (r) { setTimeout(r, 150); }); };
    /* A reward add/remove re-keys and re-indexes the OTHER cart lines (the free-gift
       discount re-allocates), so every rendered row must be refreshed — the page's
       cart-items as well as the drawer, or remove buttons keep dead keys. */
    try {
      var drawer = document.querySelector("cart-drawer");
      var drawerReloaded = false;
      if (drawer && typeof drawer.reload == "function") { drawer.reload(); drawerReloaded = true; }
      document.querySelectorAll("cart-items, cart-drawer-items").forEach(function (items) {
        if (drawerReloaded && items.tagName === "CART-DRAWER-ITEMS") return;
        if (typeof items.onCartUpdate == "function") items.onCartUpdate();
      });
    } catch (e) { console.warn("bd-kit refresh", e); }
    return done();
  }

  var lastCart = null, lastState = null, inflight = false, t = null;

  /* The theme's page-branch row refresh replaces only the cart rows: the summary
     (subtotal, shipping bar) and the is-empty classes that show/hide the empty
     state live outside <cart-items> and go stale when WE mutate the cart in the
     background. Mirror the truth from the cart we just fetched. */
  function applyCartClasses(cart) {
    var empty = cart.item_count === 0;
    document.querySelectorAll("cart-drawer, cart-drawer-items, cart-items, #main-cart").forEach(function (el) {
      el.classList.toggle("is-empty", empty);
    });
  }

  /* True when a mount is owed. A theme refresh can replace ONE host (the /cart
     summary re-renders independently) while the drawer's bar survives off-canvas —
     "any .bd-kit exists" alone would skip that remount and leave the bare host
     with the checkout gate still armed and no visible size picker. So: missing if
     no bar exists while a host does, or if any shipping-bar host has lost its bar. */
  function barMissing() {
    if (!document.querySelector(".bd-kit")) {
      return !!(document.querySelector(".drawer__shipping-bar") || document.querySelector('[name="checkout"]'));
    }
    var miss = false;
    document.querySelectorAll(".drawer__shipping-bar").forEach(function (bar) {
      var host = bar.parentElement;
      if (host && !host.querySelector(".bd-kit")) miss = true;
    });
    return miss;
  }

  function sync() {
    if (killed) return;
    /* Watchdog: a mutation whose promise never settled cleanly (network drop,
       challenge page) would leave busy stuck true and this loop spinning
       silently forever. After 8s, assume the mutation is dead and move on. */
    if (busy && Date.now() - busyAt > 8000) busy = false;
    if (busy || inflight) { schedule(); return; }
    inflight = true;
    getCart().then(function (cart) {
      inflight = false;
      failCount = 0;
      lastCart = cart;
      absorbQual();
      if (killed) return;
      var state = evaluate(cart);
      lastState = state;
      applyCartClasses(cart);
      if (reconcile(cart, state)) return;
      var sig = JSON.stringify([state.total, cart.items.map(function (i) { return i.variant_id + ":" + i.quantity; }), declined()]),
        changed = sig !== lastSig,
        missing = barMissing();
      if (changed) { lastSig = sig; addCount = 0; }
      try { mo.disconnect(); } catch (e) {}
      if (changed || missing) {
        try { mount(cart, state); } catch (e) { console.warn("bd-kit mount", e); }
      }
      try { decorate(cart); } catch (e) { console.warn("bd-kit decorate", e); }
      try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    }).catch(function (e) {
      /* /cart.js can 429 into an HTML challenge page (json() rejects). Dying
         here silently froze the whole loop mid-reconcile - retry with backoff. */
      inflight = false;
      console.warn("bd-kit sync", e);
      failCount++;
      if (failCount <= 5) setTimeout(schedule, 600 * failCount);
    });
  }

  function schedule() {
    if (killed) return;
    if (!t) t = setTimeout(function () { t = null; sync(); }, 120);
  }

  /* A theme re-render (drawer reload on add-to-cart, cart-items refresh) destroys
     the mounted bar; waiting on the debounce + /cart.js round-trip to rebuild it
     left a visible gone-then-pop gap while the drawer slides in. Re-mount
     synchronously from the cached cart/state so the bar is back in the same paint,
     then reconcile against the server in the background. */
  var mo = new MutationObserver(function () {
    if (killed) return;
    if (barMissing()) {
      if (lastCart && lastState) {
        try { mo.disconnect(); } catch (e) {}
        try { mount(lastCart, lastState); decorate(lastCart); } catch (e) { console.warn("bd-kit remount", e); }
        try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
      }
      if (!busy && !inflight) schedule();
    }
  });
  try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}

  if (document.readyState !== "loading") sync();
  else document.addEventListener("DOMContentLoaded", sync);

  ["cart:change", "cart:refresh", "cart:updated"].forEach(function (e) {
    document.addEventListener(e, schedule);
  });
  /* The theme announces every completed cart mutation on its pub-sub bus — react
     to that instead of waiting for the drawer's DOM to churn. */
  try {
    if (typeof subscribe === "function" && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
  } catch (e) {}
  document.addEventListener("click", function (ev) {
    if (ev.target.closest('[name="add"], .cart-item__remove, cart-remove-button')) schedule();
  }, true);
  window.addEventListener("pageshow", function (ev) {
    /* A bfcache back/forward restore revives rows and summary from before the
       cart changed on another page - re-render the cart page's items, then let
       sync reconcile. The drawer refreshes itself (cart-drawer.js pageshow). */
    if (ev.persisted) {
      document.querySelectorAll("cart-items").forEach(function (items) {
        if (typeof items.onCartUpdate === "function") items.onCartUpdate();
      });
    }
    schedule();
  });
})();
